import type { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";
import { isDefined } from "@recursyve/nice-ts-utils";

@Pipe({ name: "isDefined" })
export class IsDefinedPipe implements PipeTransform {
    public transform<T>(value: T | null | undefined): value is T {
        return isDefined(value);
    }
}
